



























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import type { IConsents } from "@/@types/filoxenia-config/consents";
import { preferred_language } from "@/config/languags.config.json";

import BSwitch from "@/components/app/shared/switchs/b-switch.vue";
import BSettingDd from "@/components/app/shared/btn&dd/b-setting-dd.vue";
import DashCard from "@/components/app/shared/cards/dash-card.vue";

@Component({ components: { BSwitch, BSettingDd, DashCard } })
class ConsentsCard extends Vue {
  @Prop({ type: Object, default: null }) item!: IConsents | null;
  @Prop({ type: Boolean, default: false }) deleted!: boolean;

  show = this.item?.show || false;
  consents_require = this.item?.consents_require || false;

  get posterLang(): string {
    if (!this.item || !this.item.src) return "";
    const keys = Object.keys(this.item.src.poster || {});
    const i18pref = String(this.$i18n.fallbackLocale);
    if (keys.includes(this.$i18n.locale)) return this.$i18n.locale;
    if (keys.includes(preferred_language)) return preferred_language;
    if (keys.includes("en")) return "en";
    if (keys.includes(i18pref)) return i18pref;
    return keys.length ? keys[0] : "";
  }

  get poster(): string {
    return this.item ? this.$getLocale(this.item.src.poster) : "";
  }

  get pdfName(): string {
    return this.poster.split("/").pop() || this.poster;
  }

  get posterUrl(): string {
    if (!this.item || !this.item.code || !this.posterLang) return "";
    return this.poster
      ? this.$getWebImage(
          this.poster,
          `consents/${this.item.code}/${this.posterLang}`
        )
      : "";
  }

  @Watch("show")
  changeShow(): void {
    if (!this.item) return;
    this.$emit("change", this.item._id, { show: this.show });
  }

  @Watch("consents_require")
  changeRequire(): void {
    if (!this.item) return;
    this.$emit("change", this.item._id, {
      consents_require: this.consents_require,
    });
  }
}
export default ConsentsCard;
